/* eslint-disable no-shadow */
import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { eventStateTypeIds } from '../../../../../utils/eventConstants';

const PaidHitRegistrationButtonV2 = (props) => {
    const { isCurrentMemberAdmin, handleRegClick } = props;

    const { event } = useSelector(({ eventProfile }) => {
        const { event } = eventProfile;
        return { event };
    });

    const isEventInProgress = event.data.eventStateId === eventStateTypeIds.IN_PROGRESS;
    const isEventCompleted = event.data.eventStateId === eventStateTypeIds.COMPLETED;
    const isEventRegistrationClosed = event.data.eventStateId === eventStateTypeIds.REGISTRATION_CLOSED;
    const isEventRegistrationOpen = event.data.eventStateId === eventStateTypeIds.OPEN_REGISTRATION;
    const isUserRegisteredForEvent = event.data?.currentMember?.isPlaying;

    if (isCurrentMemberAdmin) {
        return null;
    }

    const showRegister = (isEventRegistrationOpen || isUserRegisteredForEvent) && !isEventInProgress && !isEventCompleted;
    const showAlreadyRegistered = isUserRegisteredForEvent && !isEventInProgress && !isEventCompleted;

    const renderButtonText = () => {
        if (showAlreadyRegistered) {
            return 'Edit Registration';
        }
        if (isEventRegistrationClosed) {
            return 'Registration Closed';
        }
        if (isEventInProgress) {
            return 'In Progress';
        }
        if (isEventCompleted) {
            return 'Completed';
        }
    };

    return (
        <div className="register mt16">
            {showRegister ? (
                <button
                    type="button"
                    className={`btn btn-primary btn-lg text-uppercase ${event.data.published ? '' : 'disabled'}`}
                    onClick={handleRegClick}
                    data-testid="paid-hit-registration-button.register-btn"
                >
                    {showAlreadyRegistered ? 'Edit Registration' : 'Register'}
                </button>
            ) : (
                <button
                    type="button"
                    className="btn btn-primary btn-lg text-uppercase"
                    disabled={true}
                    data-testid="paid-hit-registration-button.disabled-btn"
                >
                    {renderButtonText()}
                </button>
            )}
            {!isEventInProgress && !isEventCompleted && !isUserRegisteredForEvent && (
                <p className="text-small mt8" data-testid="paid-hit-registration-button.registration-end-msg">{event.data.eventSchedule.registrationEndString}</p>
            )}
        </div>
    );
};

PaidHitRegistrationButtonV2.propTypes = {
    isCurrentMemberAdmin: PropTypes.bool,
    handleRegClick: PropTypes.func,
};
PaidHitRegistrationButtonV2.defaultProps = {
    isCurrentMemberAdmin: false,
    handleRegClick: () => { },
};

export default withRouter(PaidHitRegistrationButtonV2);
